/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
export enum ErrorMessage {
    Report = 'The Report visualisation did not load correctly.',
    Filters = 'The Report filters did not load correctly.',
    Export = 'Exported reports did not load correctly.',
    ReportView = 'Sorry, the report view does not exist.',
}
